import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UserModalComponent } from 'src/app/shared/modals/user-modal/user-modal.component';
import { UserModel } from '../../models/members/user/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: any, tenantId?: any) {
    var modalRef!: NgbModalRef;
        if(model == null){
          model = new UserModel(); 
        }
        modalRef = this.modalService.open( UserModalComponent, {windowClass : "myCustomModalClassUnderTopBar", size: 'xl', centered: false, backdrop: 'static', keyboard: false, scrollable: true });
        modalRef.componentInstance.model = model;
        modalRef.componentInstance.tenantId = tenantId;
        var sub: Subscription =  modalRef.closed.subscribe(()=>{
          this.modelChanged.emit(modalRef.componentInstance.model)
          sub.unsubscribe();
        })
  }
}